export default class Loader {

    constructor() {
        this.displayed = false
    }

    show() {
        this.displayed = true
    }

    hide() {
        this.displayed = false
    }
}